import { z } from 'zod';
import { DbSupportedCountryCode } from './shared.country-code.models';

/**
 * @deprecated use DbSupportedLanguageSchema instead
 */
export const SupportedLanguageSchema = z.enum(['nl', 'en', 'fr']);

/**
 * @deprecated use DbSupportedLanguage instead
 */
export type SupportedLanguage = z.infer<typeof SupportedLanguageSchema>;

export const DbSupportedLanguageSchema = z.enum(['nl', 'en', 'fr']);

export type DbSupportedLanguage = z.infer<typeof DbSupportedLanguageSchema>;

export function getLanguageFromCountryCode(
  countryCode: DbSupportedCountryCode | string | undefined
): DbSupportedLanguage {
  const defaultLanguage: DbSupportedLanguage = 'en';

  if (!countryCode) {
    return defaultLanguage;
  }

  switch (countryCode) {
    case 'nl': {
      return 'nl';
    }
    default: {
      return defaultLanguage;
    }
  }
}
